import { dependencies } from '../../../package.json';

export const DYNAMIC_API_VERSION_HEADER = 'x-dyn-api-version';

export const DYNAMIC_REQUEST_ID_HEADER = 'x-dyn-request-id';

export const DYNAMIC_SDK_VERSION_HEADER = 'x-dyn-version';

export const ELEVATED_ACCESS_TOKEN_HEADER = 'x-dyn-elevated-access-token';

export const MFA_TOKEN_HEADER = 'x-mfa-auth-token';

export const SESSION_PUBLIC_KEY_HEADER = 'x-dyn-session-public-key';

export const DYNAMIC_SDK_API_VERSION =
  dependencies['@dynamic-labs/sdk-api-core'];

export const DYNAMIC_SDK_SESSION_ID_HEADER = 'x-dyn-session-id';

/**
 * Reports the runtime platform (`web` or `react-native`) to the Dynamic API.
 *
 * Named `x-dynamic-platform` (not `x-dyn-*`) to match the header the legacy
 * webview-controller already sends, so the backend receives a consistent
 * platform signal across SDK generations.
 */
export const DYNAMIC_PLATFORM_HEADER = 'x-dynamic-platform';

export const CLIENT_SDK_NAME = 'ClientSDK';
